import { render, staticRenderFns } from "./ResourceInformationModal.vue?vue&type=template&id=924bdbc4"
import script from "./ResourceInformationModal.ts?vue&type=script&lang=ts&external"
export * from "./ResourceInformationModal.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports